<template>
  <Modal
    v-if="open"
    :model-value="true"
    title="Cancel import?"
    size="small"
    @update:model-value="emit('cancel')"
  >
    <p class="text-gray-700" data-cy="cancel-import-body">
      Rows already imported from {{ name }} stay imported. Rows still running
      will finish, and no new rows will start.
    </p>
    <template #footer>
      <div class="flex justify-end gap-2 p-4">
        <Button
          label="Keep importing"
          type="Secondary"
          outline
          data-cy="cancel-import-dismiss"
          @click="emit('cancel')"
        />
        <Button
          label="Cancel import"
          type="Alert"
          data-cy="cancel-import-confirm"
          @click="emit('confirm')"
        />
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import Button from "@/components/Seranova/Buttons/Button.vue";
import Modal from "@/components/Seranova/Modal/Modal.vue";

// `name` is display-ready: the hub decodes its HTML-escaped datatable text before passing it in.
defineProps<{ open: boolean; name: string }>();
const emit = defineEmits<{ confirm: []; cancel: [] }>();
</script>
